module.exports = __webpack_public_path__ + "static/media/step-2-offers.448f0666.webp";